import React, { useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Popconfirm,
  message,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import {
  BASE_URL,
  CREATE_LOP_REGIONS,
} from "utilFunctions/Constants/urlConstants";
import { deleteAPI } from "utilFunctions/Axios/AxiosRequestConfiguration";

export interface LopReason {
  id: number;
  reason: string;
}
interface LopReasonsTableIF {
  lopReasons: LopReason[];
  setLopReasons: any;
  isModalVisible: boolean;
  setIsModalVisible: any;
}
const LopReasonsTable: React.FC<LopReasonsTableIF> = ({
  lopReasons,
  setLopReasons,
  isModalVisible,
  setIsModalVisible,
}: LopReasonsTableIF) => {
  const [editingRecord, setEditingRecord] = useState<LopReason | null>(null);
  const [form] = Form.useForm();
  const { makeRequest: createReason } = usePutPostAPI(
    (res) => {
      const { data } = res || {};
      updation(data || {});
      message.success("Reason created successfully!");
    },
    (error) => {
      console.log(error);
      message.error("Failed to create post.");
    },
    "POST"
  );
  const { makeRequest: updateReason } = usePutPostAPI(
    (data) => {
      updation(data?.data || {});
      message.success("Reason updated successfully!");
    },
    (error) => {
      console.log(error);
      message.error("Failed to create post.");
    },
    "PUT"
  );
  const updation = (values: LopReason) => {
    if (editingRecord?.id) {
      setLopReasons((prev: LopReason[]) =>
        prev.map((item) =>
          item.id === editingRecord?.id
            ? { ...item, reason: values.reason }
            : item
        )
      );
    } else {
      const newArr = [...lopReasons];
      newArr.push(values);
      setLopReasons(newArr);
    }
    closeHandler();
  };
  const handleEdit = (record: LopReason) => {
    setEditingRecord(record);
    form.setFieldsValue({ reason: record.reason });
    setIsModalVisible(true);
  };

  const handleDelete = (id: number) => {
    deleteAPI({
      url: BASE_URL + CREATE_LOP_REGIONS + "/" + id,
      success: () => {
        setLopReasons((prev: LopReason[]) =>
          prev.filter((item: LopReason) => item.id !== id)
        );
        message.success("Reason deleted successfully!");
      },
      failure: (error: any) => {
        message.error(error.response?.data?.message || "Failed to delete file");
      },
      body: {},
    });
  };
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (editingRecord?.id) {
        updateReason(
          BASE_URL + CREATE_LOP_REGIONS + "/" + editingRecord?.id,
          values
        );
      } else {
        createReason(BASE_URL + CREATE_LOP_REGIONS, values);
      }
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const columns: ColumnsType<LopReason> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleEdit(record)}>Edit</Button>
          <Popconfirm
            title="Are you sure you want to delete this reason?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const closeHandler = () => {
    setIsModalVisible(false);
    setEditingRecord(null);
    form.resetFields();
  };
  return (
    <>
      <Table<LopReason>
        rowKey="id"
        columns={columns}
        dataSource={lopReasons}
        pagination={false}
        bordered
      />
      <Modal
        title={!editingRecord ? "Add Reason" : "Edit Reason"}
        open={isModalVisible}
        onOk={handleSave}
        // onClose={closeHandler}
        onCancel={closeHandler}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="reason"
            label="Reason"
            rules={[{ required: true, message: "Please enter a reason" }]}
          >
            <Input placeholder="Enter reason" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default LopReasonsTable;
